(function () {
  'use strict';

  function selectedValue(name) {
    return document.querySelector('input[name="' + name + '"]:checked').value;
  }

  function initLppConfigurator() {
    var root = document.getElementById('LegPadProtectorConfigurator');
    var variantData = document.getElementById('LppVariantData');
    if (!root || !variantData) {
      return;
    }

    var variants;
    try {
      variants = JSON.parse(variantData.textContent);
    } catch (error) {
      return;
    }

    var variantSelect = document.getElementById('ProductSelect');
    var embroideryWordingField = document.getElementById('LppEmbroideryWordingField');
    var embroideryWording = document.getElementById('LppEmbroideryWording');
    var summary = document.getElementById('LppSelectedConfiguration');
    var inputs = root.querySelectorAll('input[type="radio"]');

    function findVariant(design, foam, customisation) {
      return variants.filter(function (variant) {
        return variant.option1 === design && variant.option2 === foam && variant.option3 === customisation;
      })[0];
    }

    function formatMoney(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-NZ', {
        style: 'currency',
        currency: root.getAttribute('data-currency') || 'NZD'
      }).format(cents / 100);
    }

    function updateDisplayedPrice(variant) {
      var productPrice = document.getElementById('ProductPrice');
      if (productPrice) {
        productPrice.textContent = formatMoney(variant.price);
        productPrice.setAttribute('content', variant.price / 100);
      }
    }

    function update() {
      var design = selectedValue('lpp-design');
      var foam = selectedValue('lpp-foam');
      var customisation = selectedValue('lpp-customisation');
      var variant = findVariant(design, foam, customisation);
      var requiresEmbroideryWording = customisation.indexOf('Embroidery') !== -1;

      embroideryWordingField.hidden = !requiresEmbroideryWording;
      embroideryWording.disabled = !requiresEmbroideryWording;
      embroideryWording.required = requiresEmbroideryWording;

      if (!requiresEmbroideryWording) {
        embroideryWording.value = '';
      }

      if (!variant) {
        variantSelect.value = '';
        summary.textContent = 'This configuration is unavailable.';
        return;
      }

      variantSelect.value = String(variant.id);
      variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
      updateDisplayedPrice(variant);
      summary.textContent = 'Selected configuration: ' + variant.sku + ' — ' + formatMoney(variant.price);
    }

    Array.prototype.forEach.call(inputs, function (input) {
      input.addEventListener('change', update);
    });

    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLppConfigurator);
  } else {
    initLppConfigurator();
  }
}());
